import { createReducer } from '@reduxjs/toolkit';
import { eulaActions } from '../../..';
import { eula as eulaState } from '../../../state/eula';
import { resetCommonState } from '../../../actions/ui.actions';

const { cancelEula, fetchEula } = eulaActions;

const eula = createReducer(eulaState, builder => {
  builder.addCase(resetCommonState.type, () => ({ ...eulaState }));

  builder.addCase(fetchEula.fulfilled, (state, action) => ({
    isCancelled: false,
    eula: action.payload
  }));

  builder.addCase(cancelEula, (state, action) => ({
    ...state,
    isCancelled: action.payload
  }));
});

export { eula };
